(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('UploadedModelsPageController', UploadedModelsPageController);

    UploadedModelsPageController.$inject = ['$scope', 'uploadedModelsService', 'urlService'];

    function UploadedModelsPageController($scope, uploadedModelsService, urlService) {
        var vm = this;
        var prevModelsViewModel = $scope.$parent.vm;
        var dateFormat = "YYYY-MM-DD";

        vm.removeModel = removeModel;

        $scope.$watch("$parent.vm.pageNumber", dataChanged);
        $scope.$watch('$parent.vm.query', dataChanged);
        $scope.$watch('$parent.vm.dateRange', dataChanged);

        activate();

        // ------------------------------------------------------------------------------------

        function activate() {
            prevModelsViewModel.pageNumber = getStoredPage();
            prevModelsViewModel.query = getStoredQuery();
            prevModelsViewModel.dateRange = getStoredDateRange();

            prevModelsViewModel.load();
        }

        function removeModel(modelID) {
            uploadedModelsService.removeModel(modelID)
                .then(prevModelsViewModel.refresh);
        }

        function dataChanged(newPage, oldPage) {
            if (!angular.equals(newPage, oldPage)) {
                updateDataInUrl();
            }
        }

        // ------------------------------------------------------------------------------------

        function updateDataInUrl() {
            var params = {
                page: prevModelsViewModel.pageNumber
            };

            if (prevModelsViewModel.query) {
                params.query = prevModelsViewModel.query;
            }

            var formatedStartDate = dateToString(prevModelsViewModel.dateRange.startDate);
            if (formatedStartDate) {
                params.startDate = formatedStartDate;
            }

            var formatedEndDate = dateToString(prevModelsViewModel.dateRange.endDate);
            if (formatedStartDate) {
                params.endDate = formatedEndDate;
            }

            urlService.setHashParameters(params);
        }

        function dateToString(dateMoment) {
            return dateMoment ? dateMoment.format(dateFormat): null;
        }

        function getStoredPage() {
            var params = urlService.getHashParameters();
            var pageStr = params.page;

            if (pageStr) {
                var parsedPage = parseInt(pageStr, 10);
                var page = isNaN(parsedPage) ? 1 : parsedPage;

                return page < 1 ? 1 : page;
            }

            return 1;
        }

        function getStoredQuery() {
            var params = urlService.getHashParameters();
            return params.query;
        }

        function getStoredDateRange() {
            var startDate = getStoredStartDate();
            var endDate = getStoredEndDate();

            if (startDate === null || endDate === null) {
                startDate = null;
                endDate = null;
            }

            return {
                startDate: startDate,
                endDate: endDate
            };
        }

        function getStoredStartDate() {
            var params = urlService.getHashParameters();
            return parseDateString(params.startDate);
        }

        function getStoredEndDate() {
            var params = urlService.getHashParameters();
            return parseDateString(params.endDate);
        }

        function parseDateString(dateStr) {
            if (dateStr) {
                var parsedDate = moment(dateStr, dateFormat);
                return parsedDate.isValid() ? parsedDate : null;
            }

            return null;
        }
    }
})();
